'use es6';

import LayoutSectionEmptyPlaceholderContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionEmptyPlaceholderContainer';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAllLayoutSectionIds } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
class LayoutSectionEmptyPlaceholdersContainer extends Component {
  render() {
    const {
      allLayoutSectionIds,
      dispatchActionToEventBus
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      children: allLayoutSectionIds.map(layoutSectionId => {
        return /*#__PURE__*/_jsx(LayoutSectionEmptyPlaceholderContainer, {
          dispatchActionToEventBus: dispatchActionToEventBus,
          layoutSectionId: layoutSectionId
        }, `__hs-ls-empty-placeholder-${layoutSectionId}`);
      })
    });
  }
}
LayoutSectionEmptyPlaceholdersContainer.propTypes = {
  allLayoutSectionIds: PropTypes.array.isRequired,
  dispatchActionToEventBus: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  return {
    allLayoutSectionIds: getAllLayoutSectionIds(state)
  };
};
export default connect(mapStateToProps)(LayoutSectionEmptyPlaceholdersContainer);